import {
  Button,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { AssignmentOutlined, Check, ErrorOutline } from "@mui/icons-material";
import { ITableColumn } from "../../../../App/Typings/Table";
import { useModalHooks } from "../../../../App/State/Hooks/useModalHooks";
import { ModalType } from "../../../../App/Enums/ModalType";
import { useDispatch } from "react-redux";
import { updateAbacUser } from "../../../../App/State/Slices/AbacUserSlice";

const classes = {
  rowCell: {
    cursor: "pointer !important",
    backgroundColor: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
    textAlign: "right",
  },
  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    color: "primary.copy",
  },
};

interface IAbacUserTableCellProps {
  element: any;
  columns: ITableColumn[];
}

export default function AdminUserTableCell({
  element,
  columns,
}: IAbacUserTableCellProps) {
  var history = useHistory();

  function displayIsActive() {
    if (element.isActive) {
      return <Check sx={{ ml: "10%", color: "primary.main" }} />;
    } else {
      return <ErrorOutline sx={{ ml: "10%", color: "secondary.main" }} />;
    }
  }

  const dispatch = useDispatch();

  return (
    <>
      <TableRow
        hover
        key={element.id}
        sx={classes.rowCell}
        onClick={() => {
          dispatch(updateAbacUser(element.id));
          history.push(`/adminUserManagement/` + element.id);
        }}
      >
        {columns.map((column: ITableColumn, elementIndex: number) => {
          let value = element[column.propName];
          if (value instanceof Date) {
            value = value.toLocaleDateString("en-US");
          }
          return (
            <TableCell key={elementIndex} align="left" sx={classes.tableCell}>
              {column.propName === "isActive" ? displayIsActive() : value}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}
